"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CommonDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _excluded = ["children", "classes", "onClose"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
};
var DialogTitle = (0, _styles.withStyles)(styles)(function (props) {
  var children = props.children,
    classes = props.classes,
    onClose = props.onClose,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DialogTitle.default, _extends({
    disableTypography: true,
    className: classes.root
  }, other), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6"
  }, children), onClose ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)) : null);
});
var DialogContent = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2)
    }
  };
})(_DialogContent.default);
var DialogActions = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing(1)
    }
  };
})(_DialogActions.default);
function CommonDialog(_ref) {
  var title = _ref.title,
    onClose = _ref.onClose,
    children = _ref.children,
    dialogActions = _ref.dialogActions,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 'sm' : _ref$maxWidth,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    onClose: onClose,
    "aria-labelledby": "customized-dialog-title",
    open: true,
    fullWidth: fullWidth,
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(DialogTitle, {
    id: "customized-dialog-title",
    onClose: onClose
  }, title), /*#__PURE__*/_react.default.createElement(DialogContent, {
    dividers: true
  }, children), /*#__PURE__*/_react.default.createElement(DialogActions, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    autoFocus: true,
    disabled: (dialogActions === null || dialogActions === void 0 ? void 0 : dialogActions.disabled) || false,
    onClick: (dialogActions === null || dialogActions === void 0 ? void 0 : dialogActions.onClick) || onClose,
    color: "primary"
  }, (dialogActions === null || dialogActions === void 0 ? void 0 : dialogActions.label) || 'Close')));
}
CommonDialog.propTypes = {
  title: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired,
  dialogActions: _propTypes.default.shape({
    disabled: _propTypes.default.bool.isRequired,
    onClick: _propTypes.default.func.isRequired,
    label: _propTypes.default.string.isRequired
  }),
  maxWidth: _propTypes.default.string,
  fullWidth: _propTypes.default.bool
};